import React, { Component } from 'react';

function createMarkup(data) {
  return { __html: data };
}

class LocationLGA extends Component {
  render() {
    if ( this.props.locationData.LGA ) {
      return (
        <>
        <p>Local Government Area</p>
        <p dangerouslySetInnerHTML={createMarkup(this.props.locationData.LGA)}></p>
        </>
      )
    } else {
      return null;
    }
  }
}

export default LocationLGA;
